import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { CategoryService } from 'src/app/shared/services/category.service';
import { SponserService } from 'src/app/shared/services/sponser.service';
import { InstitutionService } from 'src/app/shared/services/institution.service';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { BatchService } from 'src/app/shared/services/batch.service';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { MatSnackBar } from '@angular/material';
import { NotificationComponent } from 'src/app/private/widget/notification/notification.component';

import { Program } from 'src/app/shared/class/program';
import { Module } from 'src/app/shared/class/module';

@Component({
  selector: 'app-application-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.css']
})
export class ApplicationFormComponent implements OnInit {

  applicationForm: FormGroup;
  httpResponseMessage: any;
  categories: any;
  sponsers: any;
  Institutions: any;
  programs: any;
  modules: any;
  filtermodule: any;
  batches: any;
  module: any;
  minDate: string;
  maxDate: string;
  errorMessage: String;

  gender: string;
  Gender: string[] = ['Male', 'Female'];
  public show: boolean = false;
  selectFiled: any;
  public resultdata: any;
  post: any;
  gradePoints;
  subjects: string;
  enrolmentNo: any = '';
  EnrolmentNum: any = '';
  grades: string;
  application: any;
  // param:any;

  selectedProgram: Program = new Program(1, 'ABC', 'asd', 'sadasdsa');
  program: any;
  varstring: string;

  // alert
  durationInSeconds = 2;
  constructor(private formbuilder: FormBuilder,
    private _categoryservice: CategoryService,
    private _sponserservice: SponserService,
    private _institutionservice: InstitutionService,
    private _programservice: ProgramService,
    private _moduleservice: ModuleService,
    private _batchservice: BatchService,
    private _applicationservice: ApplicationService,

    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.applicationForm = this.formbuilder.group({
      'FK_CategoryID': [''],
      'FK_InstitutionID': [''],
      'FK_SponserID': [''],
      'FK_ProgramID': [''],
      'ApplicationCode': ['', [Validators.required, Validators.maxLength(10)]],
      'FirstName': ['', [Validators.required, Validators.maxLength(150)]],
      'LastName': ['', [Validators.required, Validators.maxLength(150)]],
      'DateOfBirth': ['', Validators.required],
      'TownOfBirth': ['', [Validators.required, Validators.maxLength(50)]],
      'ResidentialAddress': ['', [Validators.required, Validators.maxLength(250)]],
      'PostalAddress': ['', [Validators.required, Validators.maxLength(250)]],
      'TelephoneNo': ['', [Validators.required, Validators.maxLength(20)]],
      'MobileNo': ['', [Validators.required, Validators.maxLength(20), Validators.pattern("[789][0-9]{9}")]],
      'EmailID': ['', [Validators.required, Validators.maxLength(20), Validators.pattern("[^ @]*@[^ @]*")]],
      'District': ['', [Validators.required, Validators.maxLength(50)]],
      'Contact': ['', Validators.required],
      'NextOfKin': ['', [Validators.required, Validators.maxLength(150)]],
      'Gender': ['', Validators.required],
      'Nationality': ['', [Validators.required, Validators.maxLength(20)]],
      'PassportNo': ['', [Validators.required, Validators.maxLength(20)]],
      'BGCSECompletionYear': ['', [Validators.required, Validators.maxLength(10)]],
      'BGCSETotalPoints': ['', [Validators.required, Validators.maxLength(10)]],
      // 'SignatureOfGuardian':['', Validators.required],
      'AppQualificationEntities': this.formbuilder.array([]),
      'BGCSEEntities': this.formbuilder.array([]),
    })

    this.getAllsponser();
    this.getAllInstitution();
    this.getAllProgram();
    this.getallCategory();
    //this.getapplicationCode();

  }

  public hasError = (controlName: string, errorName: string) => {
    return this.applicationForm.controls[controlName].hasError(errorName);
  }

  get QualificationForm() {
    return this.applicationForm.get('AppQualificationEntities') as FormArray
  }

  openSnackBar() {
    this.snackBar.openFromComponent(NotificationComponent, {
      duration: this.durationInSeconds * 1000,
    });
  }

  addQualification() {
    const qualificationFb = this.formbuilder.group({
      // PK_QualificationID:[],
      IstitutionName: [],
      Qualification: [],
      Grade: [],
      Year: []
    })
    this.QualificationForm.push(qualificationFb);
  }

  deleteQualification(i) {
    this.QualificationForm.removeAt(i)
  }

  // BGCSE
  get BGCSEForm() {
    return this.applicationForm.get('BGCSEEntities') as FormArray
  }

  addbgcse() {
    const BGCSEfb = this.formbuilder.group({
      Subject: [],
      Grade: []
    })
    this.BGCSEForm.push(BGCSEfb);
  }

  deleteBGCSE(i) {
    this.BGCSEForm.removeAt(i)
  }

  addGrade() {
    this.gradePoints.push(
      {
        subject: this.subjects,
        grade: this.grades
      }
    )
    sessionStorage.setItem('loadGrades', JSON.stringify(this.gradePoints));
  }

  getapplicationCode(): void {
    this._applicationservice.getApplicationCode(AppSettings.API_ENDPOINT + AppSettings.GetApplicationCode).subscribe(
      data => {
        this.application = data;
      },
      error => this.errorMessage = <any>error)
  }

  getAllProgram(): void {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  getModuleByProgramID(PK_ProgramID): void {
    this._moduleservice.getAllModule(AppSettings.API_ENDPOINT + AppSettings.GetAllModule).subscribe(
      data => {
        this.module = data;
        this.modules = this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
      error => this.errorMessage = <any>error)
  }

  getEnrollmentNo(FK_BatchID): void {

    var o = { PK_BatchID: FK_BatchID }
    this.post = JSON.stringify(o);
    this._batchservice.getEnrollment(AppSettings.API_ENDPOINT + AppSettings.GetBatchByParam, this.post).subscribe(
      data => {
        this.enrolmentNo = data;
        this.EnrolmentNum = data[0].Enrollment;

      },
      error => this.errorMessage = <any>error)
  }

  getAllBatch(): void {
    this._batchservice.getAllBatch(AppSettings.API_ENDPOINT + AppSettings.GetAllBatch).subscribe(
      data => {
        this.batches = data;
      },
      error => this.errorMessage = <any>error)
  }

  getallCategory(): void {
    this._categoryservice.getAllCategory(AppSettings.API_ENDPOINT + AppSettings.GetAllCategory)
      .subscribe(data => {
        this.categories = data;
      },
        error => this.errorMessage = <any>error)
  }

  getAllInstitution() {
    this._institutionservice.getAllInstitution(AppSettings.API_ENDPOINT + AppSettings.GetAllInstitution)
      .subscribe(data => {
        this.Institutions = data;
      });
  }

  getAllsponser() {
    this._sponserservice.getAllSponsers(AppSettings.API_ENDPOINT + AppSettings.GetAllSponser)
      .subscribe(data => {
        this.sponsers = data;
        console.log(this.sponsers);
        if (!data) {
          return;
        }
      });
  }

  // hide and show text filed
  showFiled(FK_CategoryID: any) {
    this.selectFiled = FK_CategoryID;
    if (FK_CategoryID == 1) {
      this.show = true;
    }
  }

  deleteGrade(gradepoints) {
    for (var i = 0; i < this.gradePoints.length; i++) {
      if (this.gradePoints[i]["subject"] === gradepoints) {
        this.gradePoints.splice(i, 1);
        sessionStorage.setItem('loadGrades', JSON.stringify(this.gradePoints));
      }
    }
  }

  createApplication(post): void {
    if (this.applicationForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);
    console.log(post);

    this._applicationservice.postApplication(AppSettings.API_ENDPOINT + AppSettings.CreateApplication, this.post).subscribe(
      data => {
        console.log(data);
        this.openSnackBar();
      },
      error => this.errorMessage = <any>error)
  }

  updateApplication(post) {
    if (this.applicationForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);
    this._applicationservice.updateApplication(AppSettings.API_ENDPOINT + AppSettings.UpdateApplication, this.post).subscribe(
      data => {
        this.httpResponseMessage = data
        //this.openSnackBar(this.httpResponseMessage,'');
        this.applicationForm.reset();
      },
      error => this.errorMessage = <any>error)
  }
}
export class Notification { }
